import React, { useEffect, useState, useContext } from 'react';
import CommonTable from '../common/commonTable/CommonTable';
import YearModal from './YearModal';
import ReactNotifications from '../common/reactNotifications/ReactNotifications';
import * as utilConstants from "../../utils/constants/utilsConstants";
import DeleteModal from '../common/commonModal/DeleteModal';
import { yearCrud } from '../../api/yearApi';
import PaginationComponent from '../common/pagination/Pagination';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import Context from '../../context/Context';

const Years = ({ filters: propFilters, setFilters: propSetFilters, disableTitleUpdate }) => {
    const [yearsData, setYearsData] = useState([]);
    const { setPageTitle } = useContext(Context);
    const location = useLocation();
    const navigate = useNavigate();

    const [internalFilters, setInternalFilters] = useState({});
    const filters = propFilters !== undefined ? propFilters : internalFilters;
    const setFilters = propSetFilters !== undefined ? propSetFilters : setInternalFilters;

    const columns = [
        { header: 'ID', accessor: 'id' },
        { header: 'Time Period', accessor: 'year', placeholder: `e.g. Q1'24 or 2023` },
    ];
    
    const [showYearModal, setShowYearModal] = useState(false);
    const [editingYear, setEditingYear] = useState(null);

    const [errors, setErrors] = useState({});
    const [showDelModal, setShowDelModal] = useState(false);
    const [delRow, setDelRow] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);
    
    const itemsPerPage = 10;
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const { searchQuery } = location.state || {};
        if (searchQuery) {
            setFilters({ search: searchQuery });
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, navigate, setFilters]);

    const handlePageChange = (page) => {
        setSearchParams({ p: page });
        setCurrentPage(page);
    };

    const handleDeleteClick = (row) => {
        setDelRow(row);
        setShowDelModal(true);
    };

    const handleDelete = (row) => {
        if (delRow?.id) {
            yearCrud(delRow, 'delete', (res) => {
                if (res?.status === true) {
                    ReactNotifications(res?.message, utilConstants.sucessState200);
                    fetchAllYears(currentPage, filters);
                    setShowDelModal(false);
                } else {
                    ReactNotifications(res?.data?.message, utilConstants.getErrorStatus);
                }
            })
        }
    };

    const handleAddClick = () => {
        setEditingYear(null);
        setShowYearModal(true);
    };

    const handleEditClick = (row) => {
        setEditingYear(row);
        setShowYearModal(true);
    };

    const handleModalSaveSuccess = () => {
        const pageToFetch = editingYear ? currentPage : 1;
        fetchAllYears(pageToFetch, filters);
    };

    const fetchAllYears = (page, appliedFilters) => {
        setLoading(true);
        const payload = { page, ...appliedFilters };
        yearCrud(payload, 'get', (response) => {
            if (response?.status === true) {
                setTotalCount(response?.count);
                setYearsData(response?.data);
            }
            setLoading(false);
            setHasFetched(true);
        });
    }

    useEffect(() => {
        if (!disableTitleUpdate) {
            setPageTitle('Time Period');
        }
        const pageFromUrl = parseInt(searchParams.get('p')) || 1;
        setCurrentPage(pageFromUrl);
    }, [setPageTitle, searchParams, disableTitleUpdate]);

    useEffect(() => {
        fetchAllYears(currentPage, filters);
    }, [currentPage, filters]);

    return (
        <section>
            <div className='px-4'>
                <CommonTable
                    columns={columns}
                    data={yearsData}
                    actions={['edit', 'delete']}
                    onAdd={handleAddClick}
                    onEdit={handleEditClick}
                    onDelete={handleDeleteClick}
                    addButtonText="Add"
                    loading={loading}
                    hasFetched={hasFetched}
                    isExport={false}
                    idAccessor="id"
                />
                {totalCount > 10 && <PaginationComponent
                    currentPage={currentPage}
                    totalCount={totalCount}
                    itemsPerPage={itemsPerPage}
                    onPageChange={handlePageChange}
                />}
                <YearModal
                    show={showYearModal}
                    onHide={() => setShowYearModal(false)}
                    initialData={editingYear}
                    onSaveSuccess={handleModalSaveSuccess}
                />
                <DeleteModal
                    show={showDelModal}
                    onClose={() => setShowDelModal(false)}
                    onConfirm={handleDelete}
                    title="Delete Time Period"
                    message="Are you sure you want to delete this time period? This action cannot be undone."
                />
            </div>
        </section>
    )
}

export default Years;